import React from "react";
import { useTranslation } from "react-i18next";
import { StatsView } from "../features/stats/StatsView";
import { withRestaurantId } from "../shared/components/layout";

const StatsViewWithId = withRestaurantId(StatsView);

const StatsPage: React.FC = () => {
  const { t } = useTranslation();

  return <StatsViewWithId />;
};

export default StatsPage;
